'use client';
import { Box, Skeleton, useMediaQuery, useTheme } from '@mui/material';

import { GamesViewSkeleton } from './GamesViewSkeleton';
import { SportsSidebarSkeleton } from './SportsSidebarSkeleton';
import { TradingSidebarSkeleton } from './TradingSidebarSkeleton';

export const SportsPageSkeleton = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <>
      <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>
        {/* Header Skeleton replicating SportHeader */}
        <Box sx={{ mb: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
          {/* Logo, Title, and Toggle */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
              <Skeleton variant="rounded" width={32} height={32} sx={{ borderRadius: 1 }} />
              <Skeleton variant="text" width={120} height={32} />
            </Box>
            <Skeleton variant="rounded" width={140} height={24} sx={{ borderRadius: 12 }} />
          </Box>

          {/* Games / Props Tabs and Search */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Skeleton variant="rounded" width={80} height={36} sx={{ borderRadius: 1 }} />
              <Skeleton variant="rounded" width={80} height={36} sx={{ borderRadius: 1 }} />
            </Box>
            <Skeleton variant="circular" width={24} height={24} />
          </Box>
        </Box>

        <GamesViewSkeleton />
      </Box>

      {/* Right Sidebar Skeleton - Desktop Only */}
      {isDesktop && (
        <Box
          sx={{
            width: { lg: 320, xl: 360 },
            flexShrink: 0,
          }}
        >
          <TradingSidebarSkeleton />
        </Box>
      )}
    </>
  );
};
